import RoutesComponent from './routes/routes';
import { AlertProvider } from './components/alert/alert';
import { NotificationProvider } from './shared/context/notification-context';

function App() {
  return (
    <AlertProvider>
      <NotificationProvider>
        <RoutesComponent />
      </NotificationProvider>
    </AlertProvider>
  );
}

export default App;
